<template>
  <b-container fluid>
    <b-row v-if="user.role !== 'PATIENT'">
      <b-col lg="12">
        <tab-nav :pills="true" class="iq-edit-profile d-flex pill-theme">
          <tab-nav-items :active="true" class="col-md-6 p-0" href="#send-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <i aria-hidden="true" class="ri-mail-send-line"></i>
                {{ $t("public.views.Pages.Alert.tab.send") }}
              </h4>
            </template>
          </tab-nav-items>
          <tab-nav-items :active="false" class="col-md-6 p-0" href="#recive-tab">
            <template v-slot:title>
              <h4 class="card-title title-typography-color">
                <i aria-hidden="true" class="ri-mail-fill"></i>
                {{ $t("public.views.Pages.Alert.tab.recive") }}
                <span v-if="totalPending && totalPending !== 0">({{ totalPending }})</span>
              </h4>
            </template>
          </tab-nav-items>
        </tab-nav>
      </b-col>
    </b-row>
    <b-row v-if="user.role !== 'PATIENT'">
      <b-col md="12">
        <tab-content id="pills-tabContent-1">
          <tab-content-item id="recive-tab" :active="false">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title title-typography-color">
                  <i class="far fa-bell"></i>
                  {{ $t("public.views.Pages.Alert.alerts") }}
                  <span v-if="totalPending && totalPending !== 0">( {{ totalPending }}
                    {{ $t("public.views.Pages.Alert.pendingText") }} )</span>
                </h4>
              </template>
              >
              <template v-if="user" v-slot:headerAction>
                <b-button v-if="user.role !== 'PATIENT'" class="mr-1" variant="primary" @click="openList">
                  {{ $t("public.views.Pages.Alert.list") }}
                </b-button>
                <b-button v-if="user.role !== 'PATIENT'" class="mr-1" variant="success" @click="openCreate">
                  {{ $t("public.views.Pages.Alert.create") }}
                </b-button>
              </template>
              <template v-slot:body>
                <div class="text-right">
                  <b-button class="mb-3 mr-1" variant="secondary" @click="getAlertsExcel">
                    Excel
                  </b-button>
                  <b-button v-if="totalPending !== 0" class="mb-3 mr-1" variant="warning" @click="checkReadAll">
                    {{ $t("public.views.Pages.Alert.markAllReaded") }}
                  </b-button>
                </div>
                <div>
                  <v-card-title>
                    <v-text-field v-model="search" append-icon="mdi-magnify" hide-details single-line>
                      <template slot="label">
                        <div class="search-datatable">
                          <i class="fas fa-search fa-fw"></i>
                          {{ $t("public.views.Pages.Alert.search") }}
                        </div>
                      </template>
                    </v-text-field>
                  </v-card-title>
                  <v-data-table :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'fas fa-arrow-left',
                    lastIcon: 'fas fa-arrow-right',
                    prevIcon: 'fas fa-minus',
                    nextIcon: 'fas fa-plus',
                    'items-per-page-options': [10, 25, 50],
                  }" :headers="headers" :items="alerts" :options.sync="pagination" :search="search"
                    :server-items-length="total" item-key="id">
                    <template v-slot:item.scheduled="{ item }">
                      <div v-if="item.scheduled">
                        {{ item.scheduled | adjustToTimezone("DD/MM/YYYY") }}
                      </div>
                    </template>
                    <template v-slot:item.read="{ item }">
                      <b-badge v-if="item.status && item.status === 'READ'" variant="success">
                        {{ $t("public.views.Pages.Alert.read") }}
                      </b-badge>
                      <b-badge v-else variant="warning">
                        {{ $t("public.views.Pages.Alert.pending") }}
                      </b-badge>
                    </template>
                    <template v-slot:item.userSender="{ item }">
                      <div v-if="item.userSender">
                        <b-avatar class="mr-2" v-bind:src="
                          item.userSender.avatarUrl
                            ? item.userSender.avatarUrl +
                            '/' +
                            getAuthentication()
                            : ''
                        "></b-avatar>
                        {{ item.userSender.name }}
                        {{ item.userSender.lastname }}
                        <span v-if="item.userSender.phone">({{ item.userSender.phone }})</span>
                      </div>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <div class="div-table-data">
                        <button v-if="item.status && item.status === 'PENDING'" :id="'btnCheckRead' + item.id"
                          class="item" v-on:click="checkRead(item.id)">
                          <i class="ri-check-line"></i>
                        </button>
                        <b-popover v-if="item.status && item.status === 'PENDING'" :target="'btnCheckRead' + item.id"
                          placement="botton" triggers="hover focus">
                          <template #title>{{
                            $t("public.views.Pages.Alert.markReaded")
                          }}
                          </template>
                        </b-popover>
                      </div>
                    </template>
                  </v-data-table>
                </div>
              </template>
            </iq-card>
          </tab-content-item>
          <tab-content-item id="send-tab" :active="true">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title title-typography-color">
                  <i class="far fa-bell"></i>
                  {{ $t("public.views.Pages.Alert.alerts") }}
                </h4>
              </template>
              >
              <template v-if="user" v-slot:headerAction>
                <b-button v-if="user.role !== 'PATIENT'" class="mr-1" variant="primary" @click="openList">
                  {{ $t("public.views.Pages.Alert.list") }}
                </b-button>
                <b-button v-if="user.role !== 'PATIENT'" class="mr-1" variant="success" @click="openCreate">
                  {{ $t("public.views.Pages.Alert.create") }}
                </b-button>
              </template>
              <template v-slot:body>
                <div class="text-right">
                  <b-button class="mb-3 mr-1" variant="secondary" @click="getAlertsSendExcel">
                    Excel
                  </b-button>
                </div>
                <div>
                  <v-card-title>
                    <v-text-field v-model="search" append-icon="mdi-magnify" hide-details single-line>
                      <template slot="label">
                        <div class="search-datatable">
                          <i class="fas fa-search fa-fw"></i>
                          {{ $t("public.views.Pages.Alert.search") }}
                        </div>
                      </template>
                    </v-text-field>
                  </v-card-title>
                  <v-data-table :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'fas fa-arrow-left',
                    lastIcon: 'fas fa-arrow-right',
                    prevIcon: 'fas fa-minus',
                    nextIcon: 'fas fa-plus',
                    'items-per-page-options': [10, 25, 50],
                  }" :headers="headersSend" :items="alertsSend" :options.sync="paginationSend" :search="searchSend"
                    :server-items-length="totalSend" item-key="id">
                    <template v-slot:item.scheduled="{ item }">
                      <div v-if="item.scheduled">
                        {{ item.scheduled | adjustToTimezone("DD/MM/YYYY") }}
                      </div>
                    </template>
                    <template v-slot:item.read="{ item }">
                      <b-badge v-if="item.status && item.status === 'READ'" variant="success">
                        {{ $t("public.views.Pages.Alert.read") }}
                      </b-badge>
                      <b-badge v-else variant="warning">
                        {{ $t("public.views.Pages.Alert.pending") }}
                      </b-badge>
                    </template>
                    <template v-slot:item.way="{ item }">
                      <div v-if="item.way">
                        {{ $t("public.views.Pages.Alert.way." + item.way) }}
                      </div>
                    </template>
                    <template v-slot:item.userSender="{ item }">
                      <div v-if="item.userSender">
                        <b-avatar class="mr-2" v-bind:src="
                          item.userSender.avatarUrl
                            ? item.userSender.avatarUrl +
                            '/' +
                            getAuthentication()
                            : ''
                        "></b-avatar>
                        {{ item.userSender.name }}
                        {{ item.userSender.lastname }}
                        <span v-if="item.userSender.phone">({{ item.userSender.phone }})</span>
                      </div>
                    </template>
                    <template v-slot:item.actions="{ item }"></template>
                  </v-data-table>
                </div>
              </template>
            </iq-card>
          </tab-content-item>
        </tab-content>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col>
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title title-typography-color">
              <i class="far fa-bell"></i>
              {{ $t("public.views.Pages.Alert.alerts") }}
              <span v-if="totalPending && totalPending !== 0">( {{ totalPending }}
                {{ $t("public.views.Pages.Alert.pendingText") }} )</span>
            </h4>
          </template>
          >
          <template v-if="user" v-slot:headerAction>
            <b-button v-if="user.role !== 'PATIENT'" class="mr-1" variant="primary" @click="openList">
              {{ $t("public.views.Pages.Alert.list") }}
            </b-button>
            <b-button v-if="user.role !== 'PATIENT'" class="mr-1" variant="success" @click="openCreate">
              {{ $t("public.views.Pages.Alert.create") }}
            </b-button>
          </template>
          <template v-slot:body>
            <div class="text-right">
              <b-button class="mb-3 mr-1" variant="secondary" @click="getAlertsExcel">
                Excel
              </b-button>
              <b-button v-if="totalPending !== 0" class="mb-3 mr-1" variant="warning" @click="checkReadAll">
                {{ $t("public.views.Pages.Alert.markAllReaded") }}
              </b-button>
            </div>
            <div>
              <v-card-title>
                <v-text-field v-model="search" append-icon="mdi-magnify" hide-details single-line>
                  <template slot="label">
                    <div class="search-datatable">
                      <i class="fas fa-search fa-fw"></i>
                      {{ $t("public.views.Pages.Alert.search") }}
                    </div>
                  </template>
                </v-text-field>
              </v-card-title>
              <v-data-table :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'fas fa-arrow-left',
                lastIcon: 'fas fa-arrow-right',
                prevIcon: 'fas fa-minus',
                nextIcon: 'fas fa-plus',
                'items-per-page-options': [10, 25, 50],
              }" :headers="headers" :items="alerts" :options.sync="pagination" :search="search"
                :server-items-length="total" item-key="id">
                <template v-slot:item.scheduled="{ item }">
                  <div v-if="item.scheduled">
                    {{ item.scheduled | adjustToTimezone("DD/MM/YYYY") }}
                  </div>
                </template>
                <template v-slot:item.read="{ item }">
                  <b-badge v-if="item.status && item.status === 'READ'" variant="success">
                    {{ $t("public.views.Pages.Alert.read") }}
                  </b-badge>
                  <b-badge v-else variant="warning">
                    {{ $t("public.views.Pages.Alert.pending") }}
                  </b-badge>
                </template>
                <template v-slot:item.userSender="{ item }">
                  <div v-if="item.userSender">
                    <b-avatar class="mr-2" v-bind:src="
                      item.userSender.avatarUrl
                        ? item.userSender.avatarUrl +
                        '/' +
                        getAuthentication()
                        : ''
                    "></b-avatar>
                    {{ item.userSender.name }} {{ item.userSender.lastname }}
                    <span v-if="item.userSender.phone">({{ item.userSender.phone }})</span>
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="div-table-data">
                    <button v-if="item.status && item.status === 'PENDING'" :id="'btnCheckRead' + item.id" class="item"
                      v-on:click="checkRead(item.id)">
                      <i class="ri-check-line"></i>
                    </button>
                    <b-popover v-if="item.status && item.status === 'PENDING'" :target="'btnCheckRead' + item.id"
                      placement="botton" triggers="hover focus">
                      <template #title>{{
                        $t("public.views.Pages.Alert.markReaded")
                      }}
                      </template>
                    </b-popover>
                  </div>
                </template>
              </v-data-table>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-send" centered @ok="saveFormCreate">
      <template #modal-title>
        {{ $t("public.views.Pages.Alert.modalCreate.title") }}
      </template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Alert.modalCreate.btnClose")
      }}
      </template>
      <template #modal-ok>
        {{ $t("public.views.Pages.Alert.modalCreate.btnSend") }}
      </template>

      <b-form-group label-for="name">
        <template slot="label">
          {{ $t("public.views.Pages.Alert.modalCreate.list") }}: *
        </template>

        <multiselect v-model="listPatients" :clear-on-select="false" :close-on-select="false" :disabled="disabled"
          :multiple="true" :options="listPatientsSelect" :preselect-first="false" :preserve-search="true" label="text"
          track-by="value" v-bind:deselectGroupLabel="
            $t('public.views.Pages.Alert.multiselect-list.deselectGroupLabel')
          " v-bind:deselectLabel="
  $t('public.views.Pages.Alert.multiselect-list.deselectLabel')
" v-bind:placeholder="
  $t('public.views.Pages.Alert.multiselect-list.placeholder')
" v-bind:selectGroupLabel="
  $t('public.views.Pages.Alert.multiselect-list.selectGroupLabel')
" v-bind:selectLabel="
  $t('public.views.Pages.Alert.multiselect-list.selectLabel')
" v-bind:selectedLabel="
  $t('public.views.Pages.Alert.multiselect-list.selectedLabel')
">
          <template slot="option" slot-scope="props">
            <b-list-group-item class="d-flex align-items-center">
              <span class="mr-auto title-typography-color">{{
                props.option.text
              }}</span>
            </b-list-group-item>
          </template>
          <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
              class="multiselect__single">{{ values.length }}
              {{
                $t("public.views.Pages.Alert.multiselect-list.selectedPatients")
              }}</span></template>
          <template v-if="props.option.text" slot="singleLabel" slot-scope="props"><span class="option__desc"><span
                class="option__title">
                <span class="mr-auto title-typography-color">{{
                  props.option.text
                }}</span>
              </span></span></template>
        </multiselect>

        <ul v-if="isFormPatientsErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('patients')" v-bind:key="index"
            class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>

      <b-form-group label-for="name">
        <template slot="label">
          {{ $t("public.views.Pages.Alert.modalCreate.patients") }}: *
        </template>

        <multiselect v-model="patients" :clear-on-select="false" :close-on-select="false" :disabled="disabled"
          :multiple="true" :options="patientsSelect" :preselect-first="false" :preserve-search="true" label="text"
          track-by="value" v-bind:deselectGroupLabel="
            $t('public.views.Pages.Alert.multiselect.deselectGroupLabel')
          " v-bind:deselectLabel="
  $t('public.views.Pages.Alert.multiselect.deselectLabel')
" v-bind:placeholder="
  $t('public.views.Pages.Alert.multiselect.placeholder')
" v-bind:selectGroupLabel="
  $t('public.views.Pages.Alert.multiselect.selectGroupLabel')
" v-bind:selectLabel="
  $t('public.views.Pages.Alert.multiselect.selectLabel')
" v-bind:selectedLabel="
  $t('public.views.Pages.Alert.multiselect.selectedLabel')
" @blur="checkPatient(patient)" @input="generateFormNotification">
          <template slot="option" slot-scope="props">
            <b-list-group-item class="d-flex align-items-center">
              <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
              <span class="mr-auto title-typography-color">{{
                props.option.text
              }}</span>
            </b-list-group-item>
          </template>
          <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
              class="multiselect__single">{{ values.length }}
              {{
                $t("public.views.Pages.Alert.multiselect.selectedPatients")
              }}</span></template>
          <template v-if="props.option.text" slot="singleLabel" slot-scope="props"><span class="option__desc"><span
                class="option__title">
                <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar><span
                  class="mr-auto title-typography-color">{{
                    props.option.text
                  }}</span>
              </span></span></template>
        </multiselect>

        <ul v-if="isFormPatientsErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('patients')" v-bind:key="index"
            class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>

      <b-form-group label-for="way">
        <template slot="label">Forma de notificación: *</template>
        <b-select id="way" v-model="way" :disabled="disabled" :options="waySelect" class="form-control" v-bind:class="{
          'text-danger': isFormWayErrors,
          'is-invalid': isFormWayErrors,
        }" @blur="checkWay(way)">
        </b-select>
        <ul v-if="isFormWayErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('way')" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>

      <b-form-group label-for="content">
        <template slot="label">Contenido: *</template>
        <b-form-textarea id="content" v-model="content" :disabled="disabled" max-rows="6" rows="3" v-bind:class="{
          'text-danger': isFormContentErrors,
          'is-invalid': isFormContentErrors,
        }" @blur="checkContent(content)"></b-form-textarea>
        <ul v-if="isFormContentErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('content')" v-bind:key="index"
            class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../config/pluginInit";

import { mapActions, mapGetters } from "vuex";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import validator from "vue-m-validator";

import alertService from "../../services/alert";
import utilsService from "../../services/utils";
import userService from "../../services/user";
import patientService from "../../services/patient";
import listPatientService from "../../services/listPatient";

import AlertWayEnum from "../../json/AlertWayEnum";

export default {
  name: "Alert",
  mounted() {
    xray.index();
    this.getUser();
    this.getAllPending();
    this.getAll();
    this.getAllSend();

    utilsService.auditActivity({ action: "VIEW", module: "GENERIC_ALERT", info: "" });
  },
  computed: {
    isFormContentErrors() {
      let errors = this.validatorStep1.getErrors("content");
      return errors && errors.length > 0;
    },
    isFormPatientsErrors() {
      let errors = this.validatorStep1.getErrors("patients");
      return errors && errors.length > 0;
    },
    isFormWayErrors() {
      let errors = this.validatorStep1.getErrors("way");
      return errors && errors.length > 0;
    },
    ...mapGetters({
      selectedUser: "Setting/userState",
    }),
  },
  watch: {
    pagination: {
      handler() {
        if (this.start) {
          this.getAll();
        }
        this.start = true;
      },
    },
    paginationSend: {
      handler() {
        if (this.start) {
          this.getAllSend();
        }
        this.start = true;
      },
    },
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    async getAllLists() {
      let self = this;

      listPatientService
        .getAllPagination(0, 1000)
        .then((response) => {
          if (response) {
            let combo = [];
            response.data.content.forEach(function (item) {
              let data = {
                value: item.id,
                text: item.name + " (" + item.patients.length + " pacientes)  ",
              };
              combo.push(data);
            });
            self.listPatientsSelect = combo;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "listPatientService.getAllPagination",
            module: "view-pages-alert",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        });
    },
    openList() {
      this.$router.push({
        name: "auth.professional.contact.listPatient",
      });
    },
    generateFormNotification() {
      let self = this;

      self.waySelect = JSON.parse(JSON.stringify(AlertWayEnum));

      if (this.waySelect) {
        self.waySelect.forEach(function (way) {
          if (self.patients[0]) {
            if (way.value === "EMAIL") {
              way.text += " (" + self.patients[0].email + ")";
            } else {
              way.text += " (" + self.patients[0].phone + ")";
            }
          }
        });
      }
    },
    cleanCreate() {
      this.way = "EMAIL";
      this.patients = [];
      this.listPatients = [];
      this.content = "";
      this.validatorStep1.errors = [];

      this.waySelect = JSON.parse(JSON.stringify(AlertWayEnum));
    },
    //Validation
    notFirst() {
      this.isFirstRun = false;
    },
    checkContent(_item) {
      const ITEM = _item;
      const RULE_1 = {
        expression: ITEM === "",
        name: "content",
        msg: this.$i18n.t("public.views.Pages.Alert.errors.erContent"),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkPatients(_item) {
      const ITEM = _item;
      const RULE_1 = {
        expression: ITEM.length === 0,
        name: "patients",
        msg: this.$i18n.t("public.views.Pages.Alert.errors.erPatients"),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkWay(_item) {
      const ITEM = _item;
      const RULE_1 = {
        expression: ITEM === "",
        name: "way",
        msg: this.$i18n.t("public.views.Pages.Alert.errors.erWay"),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkFormCreate() {
      this.checkContent(this.content);
      this.checkWay(this.way);
    },
    saveFormCreate(evt) {
      evt.preventDefault();

      this.checkFormCreate();

      if (this.validatorStep1.errors.length === 0) {
        if (this.listPatients && this.listPatients.length > 0) {
          this.sendAlertList();
        } else if (this.patients && this.patients.length > 0) {
          this.sendAlert();
        } else {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t("public.views.Pages.Alert.notification.error"),
            text: this.$i18n.t(
              "public.views.Pages.Alert.notification.descErrorCreate"
            ),
            type: "error",
          });
        }
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t("public.views.Pages.Alert.notification.error"),
          text: this.$i18n.t(
            "public.views.Pages.Alert.notification.descErrorCreate"
          ),
          type: "error",
        });
      }
    },
    sendAlertList() {
      let self = this;

      let data = [];

      if (this.listPatients && this.listPatients.length != 0) {
        this.listPatients.forEach(function (item) {
          let obj = {
            way: self.way,
            listPatientId: item.value,
            text: self.content,
          };
          data.push(obj);
        });
      }

      this.$awn.asyncBlock(
        alertService.createList(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "GENERIC_ALERT", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Alert.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Alert.notification.sendAlert"
              ),
              type: "success",
            });
            self.$bvModal.hide("modal-send");
            self.getAllSend();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "alertService.createList",
            module: "view-pages-alert",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    sendAlert() {
      let self = this;

      let data = [];

      if (this.patients && this.patients.length != 0) {
        this.patients.forEach(function (patient) {
          let obj = {
            way: self.way,
            userSendee: patient.value,
            text: self.content,
          };
          data.push(obj);
        });
      }

      this.$awn.asyncBlock(
        alertService.create(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "GENERIC_ALERT", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Alert.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Alert.notification.sendAlert"
              ),
              type: "success",
            });
            self.$bvModal.hide("modal-send");
            self.getAllSend();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "alertService.create",
            module: "view-pages-alert",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    openCreate() {
      this.cleanCreate();
      this.getAllPatientsSelect();
    },
    async getUser() {
      let self = this;

      this.$awn.asyncBlock(
        userService.get(localStorage.getItem("userId")),
        (response) => {
          if (response) {
            self.user = response.data;

            if (self.user.role !== "PATIENT") {
              this.getAllLists();
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "userService.get",
            module: "view-pages-alert",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            })
          });
        },
        " "
      );
    },
    getAlertsExcel() {
      utilsService.auditActivity({ action: "CREATE", module: "GENERIC_ALERT_EXCEL", info: "" });
      var objectUrl =
        process.env.VUE_APP_BASE_URL_CORE +
        "auth/alerts/pagination/excel?token=" +
        localStorage.getItem("authorization");
      window.open(objectUrl);
    },
    getAlertsSendExcel() {
      utilsService.auditActivity({ action: "CREATE", module: "GENERIC_ALERT_EXCEL", info: "" });
      var objectUrl =
        process.env.VUE_APP_BASE_URL_CORE +
        "auth/alerts/pagination/send/excel?token=" +
        localStorage.getItem("authorization");
      window.open(objectUrl);
    },
    async getAllPending() {
      let self = this;

      this.$awn.asyncBlock(
        alertService.getAllPending(0, 5),
        (response) => {
          if (response) {
            self.totalPending = response.data.pageable.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "alertService.getAllPending",
            module: "view-pages-alert",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        },
        " "
      );
    },
    checkReadAll() {
      let self = this;

      this.$awn.asyncBlock(
        alertService.checkReadAll(),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "GENERIC_ALERT", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Alert.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Alert.notification.descAllMarkRead"
              ),
              type: "success",
            });
            self.getAll();
          }
        },
        (error) => {
          self.$notify({
            group: "notificacions",
            title: this.$i18n.t("public.views.Pages.Alert.notification.error"),
            text: this.$i18n.t(
              "public.views.Pages.Alert.notification.descErrorLater"
            ),
            type: "error",
          });
        },
        " "
      );
    },
    checkRead(id) {
      let self = this;

      this.$awn.asyncBlock(
        alertService.get(id),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "GENERIC_ALERT", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Alert.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Alert.notification.descAlertRead"
              ),
              type: "success",
            });
            self.getAll();
          }
        },
        (error) => {
          self.$notify({
            group: "notificacions",
            title: this.$i18n.t("public.views.Pages.Alert.notification.error"),
            text: this.$i18n.t(
              "public.views.Pages.Alert.notification.descErrorRead"
            ),
            type: "error",
          });
        },
        " "
      );
    },
    async getAll() {
      let self = this;

      this.$awn.asyncBlock(
        alertService.getAllPagination(
          this.pagination.page - 1,
          this.pagination.itemsPerPage
        ),
        (response) => {
          if (response) {
            self.alerts = response.data.content;
            self.total = response.data.pageable.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "alertService.getAllPagination",
            module: "view-pages-alert",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage
            })
          });
        },
        " "
      );
    },
    async getAllSend() {
      let self = this;

      this.$awn.asyncBlock(
        alertService.getAllPaginationSend(
          this.paginationSend.page - 1,
          this.paginationSend.itemsPerPage
        ),
        (response) => {
          if (response) {
            self.alertsSend = response.data.content;
            self.totalSend = response.data.pageable.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "alertService.getAllPaginationSend",
            module: "view-pages-alert",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage
            })
          });
        },
        " "
      );
    },
    async getAllPatientsSelect() {
      let self = this;

      this.$awn.asyncBlock(
        patientService.getAllActive(),
        (response) => {
          let combo = [];
          response.data.forEach(function (item) {
            let data = {
              avatar: item.avatarUrl
                ? item.avatarUrl + "/" + localStorage.getItem("authorization")
                : "",
              value: item.id,
              text:
                item.name + " " + item.lastname + " (" + item.document + ") ",
              phone: item.phone,
              email: item.email,
            };
            combo.push(data);
          });
          self.patientsSelect = combo;

          this.$bvModal.show("modal-send");
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.getAllActive",
            module: "view-pages-alert",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        },
        " "
      );
    },
  },
  data() {
    return {
      start: false,
      isFirstRun: true,
      disabled: false,
      patientsSelect: [],
      waySelect: AlertWayEnum,
      way: "EMAIL",
      patients: [],
      listPatients: [],
      content: "",
      validatorStep1: validator,

      listPatientsSelect: [],

      user: {},
      total: 0,
      totalSend: 0,
      totalPending: 0,
      pagination: {},
      paginationSend: {},
      search: "",
      searchSend: "",

      headers: [
        {
          text: this.$i18n.t("public.views.Pages.Alert.headers.read"),
          value: "read",
        },
        {
          text: this.$i18n.t("public.views.Pages.Alert.headers.date"),
          align: "start",
          value: "scheduled",
        },
        {
          text: this.$i18n.t("public.views.Pages.Alert.headers.user"),
          value: "userSender",
        },
        {
          text: this.$i18n.t("public.views.Pages.Alert.headers.notice"),
          value: "text",
        },
        { text: "", value: "actions" },
      ],
      headersSend: [
        {
          text: this.$i18n.t("public.views.Pages.Alert.headers.date"),
          align: "start",
          value: "scheduled",
        },
        {
          text: this.$i18n.t("public.views.Pages.Alert.headers.user"),
          value: "userSender",
        },
        {
          text: this.$i18n.t("public.views.Pages.Alert.headers.way"),
          value: "way",
        },
        {
          text: this.$i18n.t("public.views.Pages.Alert.headers.notice"),
          value: "text",
        },
        { text: "", value: "actions" },
      ],
      alerts: [],
      alertsSend: [],
    };
  },
  components: {
    Multiselect,
  },
};
</script>
